<form novalidate #propertyAgentPromoteSectionForm="ngForm">
  @if (draftLoaded$ | async) {
    <div class="property_agent_promote_section">
      @if (!usePartnershipAgreement()) {
        <tg-row>
          <tg-col sm="12">
            <h1 class="property-agent-promote-section__title">
              Choose your marketing package
            </h1>
          </tg-col>
          <tg-col
            lg="5"
            md="6"
            sm="12"
            class="property-agent-promote-section__lead-copy"
            >
            <p class="p-lead-copy">
              <a
                href="https://www.trademe.co.nz/c/property-industry/product/marketing-packages"
                target="_blank"
                >Learn more</a
                >
                about what's included in each marketing package, and
                download the latest information pack.
              </p>
              <p
                class="property-agent-promote-section__secondary-copy p-secondary-copy"
                >
                A fee applies to this listing. Check your rate card for
                details.
              </p>
            </tg-col>
          </tg-row>
          @if (shouldShowInfobox()) {
            <tg-row>
              <tg-col lg="5" md="6" sm="12">
                <tg-info-box>
                  <p>
                    If you would like to modify your marketing package,
                    please contact
                    <a href="mailto:{{defaultContactSupportEmail}}"
                      >{{defaultContactSupportEmail}}</a
                      >
                      (subject to Advertising Agreement terms).
                    </p>
                  </tg-info-box>
                </tg-col>
              </tg-row>
            }
            <tg-row
                [ngClass]="{
                    'property-agent-promote-section__error': displayError
                }"
              >
              <tg-col lg="4" md="6" sm="12">
                @for (package of packages; track package.code) {
                  <div
                    (click)="publish()"
                        [ngClass]="{
                            'property-agent-promote-section__disabled':
                                shouldDisableCards()
                        }"
                    >
                    <tg-card
                      bordered
                      class="property-agent-promote-section__card"
                            [ngClass]="{
                                selectedCard:
                                    package.code === selectedPackage.code,
                                disabled: shouldDisableCards()
                            }"
                      >
                      <tg-row>
                        <tg-col sm="12">
                          <label class="container"
                            >{{ package.name }}
                            <input
                              type="radio"
                              [id]="package.name"
                              name="packageCode"
                              [value]="package.code"
                                            [(ngModel)]="
                                                draftData.propertyPromote
                                                    .packageCode
                                            "
                                            [validation]="
                                                validation.propertyPromote
                                                    .packageCode | toValidator
                                            "
                                            (change)="
                                                onSelectPackage(package.code)
                                            "
                              /><span
                                            [ngClass]="{
                                                disabled: shouldDisableCards()
                                            }"
                              class="checkmark"
                            ></span>
                          </label>
                        </tg-col>
                      </tg-row>
                    </tg-card>
                  </div>
                }
              </tg-col>
            </tg-row>
            <tg-row
                [ngClass]="{
                    'property-agent-promote-section__error': displayError
                }"
              >
              <tg-col lg="6" md="12">
                <tg-checkbox
                  name="basePackageSelection"
                  class="property-agent-promote-section__base-checkbox"
                  (change)="onBasePackageSelection($event.value)"
                  [(ngModel)]="basePackageSelection"
                        [validation]="
                            validation.propertyPromote.basePackageSelection
                                | toValidator
                        "
                  [disabled]="shouldDisableCheckboxes()"
                  >
                  <tg-label>
                    Don't include a marketing package. List as a
                    <b>Base Listing</b>
                  </tg-label></tg-checkbox
                  >
                </tg-col>
              </tg-row>
            }
            @if (usePartnershipAgreement()) {
              <tg-row>
                <tg-col>
                  <h1 class="property-agent-promote-section__title">
                    Your Partnership Agreement package has been applied
                  </h1>
                </tg-col>
              </tg-row>
              <tg-row>
                <tg-col class="property-agent-promote-section__lead-copy">
                  <p class="p-lead-copy">
                    A fee applies to this listing. Check your rate card for
                    details.
                  </p>
                </tg-col>
              </tg-row>
              <tg-row>
                <tg-col
                  md="6"
                  sm="12"
                  class="property-agent-promote-section__pa-info-copy"
                  >
                  <tg-info-box>
                    <p>
                      If you would like to modify your marketing package,
                      please complete your listing then contact
                      <a href="mailto:{{defaultContactSupportEmail}}"
                        >{{defaultContactSupportEmail}}</a
                        >
                        or your account manager within 24 hours (subject to
                        Advertising Agreement terms).
                      </p>
                    </tg-info-box>
                  </tg-col>
                </tg-row>
              }
            </div>
          }
        </form>
